import React from "react"
import PropTypes from "prop-types"

const KeyIndicator = props => {
  const length = props.value.length
  return (
    <div className="clock-in-keypad__indicator">
      {[0, 1, 2, 3].map(i => <div key={i} className={`clock-in-keypad__indicator-item ${length > i ? "filled" : ""}`}/>)}
    </div>
  )
}

const Keypad = props => {
  return (
    <div className="clock-in-keypad">
      {props.showIndicator && <KeyIndicator value={props.value}/>}
      <div className="clock-in-keypad__keys-wrapper">
        {
          [1,2,3,4,5,6,7,8,9].map(i =>
            <button key={i} className="clock-in-keypad__key" onClick={props.onClickNumber.bind(null, i)}>{i}</button>
          )
        }
        <button className="clock-in-keypad__key" disabled={!props.onClickStats || props.value.length !== 4}
          title="Stats" onClick={props.onClickStats}>
          <img src="/images/clock-in/keypad-stats.png"/>
        </button>
        <button className="clock-in-keypad__key" onClick={props.onClickNumber.bind(null, 0)}>0</button>
        <button className="clock-in-keypad__key" title="Delete" onClick={props.onClickDelete}>
          <img src="/images/clock-in/keypad-delete.png"/>
        </button>
      </div>
      <button className={`clock-in-keypad__submit ${props.submitButtonClass}`}
        disabled={props.value.length !== 4} onClick={props.onClickSubmit}>
        {props.submitButtonText}
      </button>
    </div>
  )
}

Keypad.propTypes = {
  submitButtonClass: PropTypes.string,
  submitButtonText: PropTypes.string,
  showIndicator: PropTypes.bool,
  onClickNumber: PropTypes.func,
  onClickStats: PropTypes.func,
  onClickSubmit: PropTypes.func
}

export default Keypad
